export const contactData = {
  heading: "Let's Solve Your Tech Challenges",
  description:
    "We're excited to learn about your organization. Whether you have a specific project ready to go or are just starting to explore how technology can streamline your work, we're here to help.",
  bulletPoints: [
    "Get expert advice on a frustrating technical problem",
    "Discuss your specific data, automation, or software needs",
    "Learn how technology can be a force multiplier for your organization",
    "See if we're the right technology partner for your mission",
  ],
  contact: {
    email: "info@grantyd.com",
  },
  socialLinks: [
    {
      platform: "instagram",
      url: "https://instagram.com/getgrantyd",
      icon: "InstagramIcon",
    },
    {
      platform: "linkedin",
      url: "https://linkedin.com/company/grantyd",
      icon: "LinkedInIcon",
    },
  ],
  form: {
    fields: [
      {
        label: "First Name",
        name: "firstName",
        required: true,
        autoComplete: "given-name",
        minLength: 2,
      },
      {
        label: "Last Name",
        name: "lastName",
        required: true,
        autoComplete: "family-name",
        minLength: 2,
      },
      {
        label: "Work Email",
        name: "workEmail",
        required: true,
        autoComplete: "email",
        type: "email",
      },
      {
        label: "Job Title",
        name: "jobTitle",
        required: true,
        autoComplete: "organization-title",
        minLength: 2,
      },
      {
        label: "Organization Name",
        name: "organizationName",
        required: true,
        autoComplete: "organization-title",
        minLength: 3,
      },

      {
        label: "How did you hear about Grantyd?",
        name: "referralSource",
        options: ["LinkedIn", "Twitter", "Friend", "Other"],
      },
    ],
    submitButton: "Get In Touch",
  },
};
